import { useState } from "react";

const faqs = [
  {
    question: "Was ist OOPBUY?",
    answer:
      "OOPBUY ist ein führender Shopping-Agent für chinesische Marktplätze wie Taobao, Weidian und 1688. Die Plattform ermöglicht es Käufern weltweit, Produkte aus China zu bestellen, die Qualität zu prüfen (QC) und sicher nach Deutschland sowie in andere Länder versenden zu lassen.",
  },
  {
    question: "Was ist oopbuyspread.beer?",
    answer:
      "oopbuyspread.beer ist eine unabhängige Informationsplattform und ein kuratierter Guide für OOPBUY-Käufer. Wir bieten die größte öffentlich zugängliche Spreadsheet mit über 3.000 verifizierten Produkten, täglich aktualisiert. Diese Website ist rein informativ und fungiert als SEO-Guide für alle, die mit OOPBUY einkaufen möchten.",
  },
  {
    question: "Warum sollte ich eine Website-Spreadsheet nutzen?",
    answer:
      "Eine kuratierte Spreadsheet spart dir Stunden an Recherche. Statt stundenlang Taobao oder Weidian nach vertrauenswürdigen Verkäufern zu durchsuchen, findest du bei uns bereits geprüfte Produkte mit verifizierten QC-Fotos. Du siehst auf einen Blick, welche Artikel empfohlen werden und welche Verkäufer seriös sind.",
  },
  {
    question: "Wie bekomme ich zusätzlichen Support?",
    answer:
      "Für Support bei Bestellungen, Versandfragen oder spezifischen Produktanfragen empfehlen wir dir, den offiziellen OOPBUY-Kundenservice zu kontaktieren. Du erreichst sie über die Hauptwebsite. Für Fragen zu unserer Spreadsheet kannst du die Guides auf dieser Seite lesen.",
  },
  {
    question: "Wie platziere ich eine Bestellung bei OOPBUY?",
    answer:
      "1. Erstelle ein Konto auf der offiziellen OOPBUY-Website. 2. Suche das gewünschte Produkt oder nutze unsere Spreadsheet, um Links zu finden. 3. Füge den Produktlink in deinen Warenkorb ein. 4. Wähle deine gewünschten Optionen (Größe, Farbe). 5. Bezahle und warte auf die QC-Fotos. 6. Bestätige den Versand nach Deutschland.",
  },
  {
    question: "Können Sie mir bei der Suche nach einem bestimmten Produkt helfen?",
    answer:
      "Unsere Spreadsheet deckt die beliebtesten Kategorien ab: Schuhe, Hoodies, T-Shirts, Jacken, Hosen, Kopfbedeckungen, Sets, Unterwäsche, Trikots, Accessoires, Taschen, Gürtel, Parfums und mehr. Nutze die Kategorie-Filter auf unserer Seite oder auf der Hauptwebsite, um gezielt zu suchen.",
  },
  {
    question: "Warum OOPBUY statt anderer Shipping Agents?",
    answer:
      "OOPBUY besticht durch eine benutzerfreundliche Oberfläche, schnelle QC-Fotos, wettbewerbsfähige Versandpreise und einen zuverlässigen Kundenservice. Die Plattform unterstützt zudem alle gängigen chinesischen Marktplätze und bietet regelmäßig Coupons sowie Aktionen für Stammkunden.",
  },
  {
    question: "Was ist eine OOPBUY Spreadsheet?",
    answer:
      "Eine OOPBUY Spreadsheet ist eine öffentlich zugängliche Liste kuratierter Produkte von verifizierten Verkäufern. Jeder Eintrag enthält Produktlinks, Preise, Verkäuferbewertungen und oft auch QC-Fotos. Sie dient als Shortcut für Käufer, die nicht stundenlang selbst recherchieren möchten, sondern sofort wissen, welche Artikel empfohlen werden.",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="bg-background-100 py-12 md:py-20">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              Häufig gestellte Fragen
            </h2>
            <p className="text-sm text-foreground-600">
              Alles, was du über OOPBUY und unsere Spreadsheet wissen musst.
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                >
                  <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                    {faq.question}
                  </span>
                  <span className="w-6 h-6 flex items-center justify-center text-foreground-500 shrink-0">
                    <i
                      className={`ri-add-line transition-transform ${
                        openIndex === index ? "rotate-45" : ""
                      }`}
                    ></i>
                  </span>
                </button>
                {openIndex === index && (
                  <div className="px-4 md:px-5 pb-4 md:pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}